import {
    calcDays, subtractFromNow,
} from './daysToSecondsFromNow'
import dateTimeMask from './dateTimeMask'
import strToMoment from './strToMoment'
import timestampToUTCDateStr from './timestampToUTCDateStr'

type FilterValues<T = number> = {
    from: T,
    to: T,
}

// operates on timestamps
export const parseFromFilterDaysValue = (value: FilterValues) => {
    return value?.to ? calcDays(value?.to) : undefined
}

export const parseToFilterDaysValue = (value: FilterValues) => {
    return value?.from ? calcDays(value?.from) : undefined
}

export const convertFromFilterDaysValue = (value: FilterValues) => {
    return value?.to ? subtractFromNow(value?.to) : undefined
}

export const convertToFilterDaysValue = (value: FilterValues) => {
    return value?.from ? subtractFromNow(value?.from) : undefined
}

// operates on date strings
const parseFilterDatesToTimestamps = (value: FilterValues<string>) => {
    return {
        from: strToMoment(value.from, dateTimeMask)?.unix(),
        to: strToMoment(value.to, dateTimeMask)?.unix(),
    }
}

export const parseFromFilterDaysDate = (value: FilterValues<string>) => {
    return parseFromFilterDaysValue(parseFilterDatesToTimestamps(value))
}

export const parseToFilterDaysDate = (value: FilterValues<string>) => {
    return parseToFilterDaysValue(parseFilterDatesToTimestamps(value))
}

export const convertFromFilterDaysDate = (value: FilterValues) => {
    return timestampToUTCDateStr(convertFromFilterDaysValue(value))
}

export const convertToFilterDaysDate = (value: FilterValues) => {
    return timestampToUTCDateStr(convertToFilterDaysValue(value))
}
